import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FullOffer } from 'app/shared/models/class/offer/offer';
import { DataService } from 'app/shared/services/data/data.service';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';
import { SubscriptionBaseComponent } from 'app/shared/subscriptionBase/subscription-base';

@Component({
  selector: 'app-pop-up-shopping-basket',
  templateUrl: './pop-up-shopping-basket.component.html',
  styleUrls: ['./pop-up-shopping-basket.component.scss']
})

export class PopUpShoppingBasketComponent extends SubscriptionBaseComponent implements OnInit {

  myShoppingBag: FullOffer[];

  constructor(
    private dataService: DataService,
    private cdr: ChangeDetectorRef,
    private faIconService: FaiconService,

  ) {
    super();
  }

  ngOnInit(): void {
    this.initSub();
  }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  close(): void {
    this.dataService.resetPopUp();
  }

  private initSub(): void {
    this.subscription.add(
      this.dataService.myShoppingBag.asObservable().subscribe({
        next: myShoppingBag => { this.myShoppingBag = myShoppingBag; this.cdr.detectChanges(); }
      })
    );
  }

}
